import { AudioFilesEditorOutput } from './audio-files-editor-output';

export const defaultAudioFilesEditorOutput: AudioFilesEditorOutput = {
  displayName: '',
  currentLanguage: 'en',
  audioByLanguage: {},
};
